// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPageErrorIndicator_root__2QtuA","message":"FullPageErrorIndicator_message__3pUtR"};